import script from "./ValueSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./ValueSlider.vue?vue&type=script&setup=true&lang=ts"

import "./ValueSlider.vue?vue&type=style&index=0&id=d160b164&lang=scss"

const __exports__ = script;

export default __exports__